var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sb-paytable-win-lines"},[_c('img',{attrs:{"src":'./assets/common/paytable/win_lines.png',"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }